import { CommonModule } from '@angular/common';
import { PanelTableModule } from './../../shared-panel-components/panel-table/panel-table.module';
import { PanelModule } from './../../shared-panel-components/panel/panel.module';
import { AttendancePanelComponent } from './attendance-panel.component';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [AttendancePanelComponent],
  imports: [PanelModule, PanelTableModule, CommonModule],
  exports: [AttendancePanelComponent],
  providers: [],
})
export class AttendancePanelModule {}
